
      import { Buffer } from "buffer";
      window.Buffer = window.Buffer || Buffer;

      var env = "release"

      if(env !== 'release') {
        console.info(`environment: ${env}`)
      }
    